import { defineComponent as _defineComponent } from 'vue';
import { ref, set } from "vue";
import {} from "@/api/schema";
import ContentItem from "./ContentItem.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'GenericElement',
    props: {
        dsc: {
            type: Object,
            required: true,
        },
    },
    setup(__props) {
        const expandCollections = ref({});
        const expandDatasets = ref({});
        function toggle(expansionMap, itemId) {
            set(expansionMap, itemId, !expansionMap[itemId]);
        }
        return { __sfc: true, expandCollections, expandDatasets, toggle, ContentItem };
    }
});
